import { Alert, AlertIcon, Box, Link, Text } from "@chakra-ui/react";
import { useAppSelector } from "app/hooks";
import { ROUTES } from "constants/routes";
import { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { formatTwoFactorDeadline } from "utils/twoFactor";

export default function TwoFactorSetupBanner() {
  const setup = useAppSelector((state) => state.profile.twoFactorSetup);
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!setup?.two_factor_setup_required) return;
    setNow(Date.now());
    const timer = window.setInterval(() => setNow(Date.now()), 60000);
    return () => window.clearInterval(timer);
  }, [setup?.two_factor_setup_required]);
  if (!setup?.two_factor_setup_required) return null;
  const deadline = setup.two_factor_deadline_at;
  const formatted = deadline ? formatTwoFactorDeadline(deadline) : null;
  const urgent = deadline ? new Date(deadline).getTime() - now <= 86400000 : false;
  return (
    <Alert status={urgent ? "error" : "warning"} borderRadius="md" alignItems="start">
      <AlertIcon />
      <Box>
        <Text>{formatted
          ? `Set up two-factor authentication by ${formatted} or your account will be disabled.`
          : "Set up two-factor authentication to prevent your account from being disabled."}</Text>
        <Link as={RouterLink} to={`${ROUTES.PROFILE.path}?tab=2fa`} fontWeight="bold" textDecoration="underline">
          Set up two-factor authentication
        </Link>
      </Box>
    </Alert>
  );
}
